import React from 'react';
import PropTypes from 'prop-types';

import ReactPlayer from 'react-player/vimeo';

export default function Header({ className, resource }) {
  return (
    <section>
      <div className={`d-xl-flex gap-4 justify-content-between ${className}`}>
        <div className="mb-3">
          <h1 className="mb-3">
            {resource
              ? resource.attributes.title
              : 'Welcome to LeggUP’s Ultimate Leadership Resource Hub!'}
          </h1>
          <p className="mb-3">
            {resource ? resource.attributes.description
              : `Unlock your potential with LeggUP! 
              Discover everything you need to jumpstart a powerful coaching journey designed just for you. 
              Dive in and begin transforming your career today!`}
          </p>
        </div>
        {resource && resource.attributes.vimeo !== '' && (
          <div>
            <ReactPlayer
              url={resource.attributes.vimeo}
              controls
              className="resource-video-promote mx-auto"
              style={{
                borderRadius: '20px', overflow: 'hidden', width: '100%', height: '100%',
              }}
            />

          </div>
        )}
      </div>
    </section>
  );
}

Header.propTypes = {
  resource: PropTypes.object,
  className: PropTypes.string,
};

Header.defaultProps = {
  resource: null,
  className: '',
};
